export enum GlassType {
  Glass = 'Glass',
  Panel = 'Panel',
}
